import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import CustomForm from "../general/form/CustomForm";
import useFormWithDisable from "../../auxiliar/customHooks/useFormWithDisable";
import { putClinicSchedule, getClinicSchedule } from "../../actions/clinics";

const Schedule = () => {
    const [isEditing, setIsEditing] = useState(false);

    const {
        register,
        handleSubmit,
        handleSubmitWithoutValidation,
        fetchFormValues,
        errors,
        isSubmitting,
        watch,
        setValue,
        resetFetchedValues,
        isLoadingData,
    } = useFormWithDisable(true);

    const clinicId = useSelector((state) => state.activeClinic.id);
    const userType = useSelector((state) => state.auth.user_type);

    useEffect(() => {
        if (clinicId) fetchFormValues(getClinicSchedule, clinicId);
    }, [clinicId]);

    useEffect(() => {
        if (!isEditing && clinicId) resetFetchedValues();
    }, [isEditing]);

    const formConfig = {
        schedule: {
            condition: true,
            disabled: !isEditing,
            type: "schedule",
            watch: watch,
            setValue: setValue,
        },
    };

    return (
        <section>
            <h2 className="sr-only">Horario de la clínica de fisioterapia en MiFisio Agenda</h2>

            <h3 className="text-primary text-2xl">Horario de la Clínica</h3>

            <form className="my-3">
                <CustomForm
                    formConfig={formConfig}
                    errors={errors}
                    register={register}
                    className="grid grid-cols-1 md:grid-cols-2 gap-3"
                    isLoading={isLoadingData}
                />

                {userType === "manager" && (
                    <div className="mt-5 flex space-x-2 sm:space-x-4">
                        {!isEditing ? (
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={handleSubmitWithoutValidation(setIsEditing, true)}
                                disabled={isSubmitting}
                            >
                                Editar
                            </button>
                        ) : (
                            <>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={handleSubmit(
                                        putClinicSchedule,
                                        clinicId,
                                        handleSubmitWithoutValidation(setIsEditing, false),
                                    )}
                                    disabled={isSubmitting}
                                >
                                    Guardar
                                </button>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={handleSubmitWithoutValidation(setIsEditing, false)}
                                    disabled={isSubmitting}
                                >
                                    Cancelar
                                </button>
                            </>
                        )}
                    </div>
                )}
            </form>
        </section>
    );
};

export default Schedule;
